<template>
  <div class="d-flex flex-column align-items-start">
    <b-form-radio-group
      class="mb-2"
      buttons
      button-variant="light-tab"
      v-model="currentTabName"
      :options="tabs"
      value-field="name"
      text-field="title"
    />
    <component
      :is="currentTab.component"
      v-bind="tabBinds"
      v-on="tabEvents"
    />
  </div>
</template>
<style lang="sass" scoped>
::v-deep .btn-light-tab
  border: none
  color: var(--font-color-primary) !important
  text-transform: initial !important
  cursor: pointer
  font-weight: normal !important
  box-shadow: none !important
  outline: none !important
  padding-left: 1.5rem
  padding-right: 1.5rem
  &.active
    color: var(--color-primary) !important
    border-bottom: .35rem solid var(--color-primary) !important
    border-radius: 0 !important
</style>
<script>
export default {
  props: {
    tabs: {
      type: Array,
      required: true,
    },
    tabBinds: {
      type: Object,
      required: false,
    },
    tabEvents: {
      type: Object,
      required: false,
    },
  },
  created() {
    this.goToFirstTab();
  },
  watch: {
    tabs() {
      this.goToFirstTab();
    },
  },
  data: () => ({
    currentTabName: 'individual-analysis',
  }),
  methods: {
    goToFirstTab() {
      this.currentTabName = this.tabs[0].name;
    },
  },
  computed: {
    currentTab() {
      return this.tabs.find(({ name }) => this.currentTabName === name);
    },
  },
};
</script>
